// export const BASE_URL = "http://192.168.30.33:8081/"; //Staging
// export const BASE_URL = "http://192.168.30.33:7061/"; //QA Environmente
// export const BASE_URL = "https://cmp.sourcingbrains.com/backend/"; //production
// export const BASE_URL = "http://192.168.60.190:8081/";   // Reetesh
// export const BASE_URL = "http://192.168.20.154:8081/";  //Abhisekh

const hostname = typeof window !== "undefined" ? window.location.hostname : "";

let BASE_URL = "";

if (hostname === "localhost" || hostname.startsWith("192.168.")) {
  // BASE_URL = "http://192.168.60.218:7061/"; //reetesh
  // BASE_URL = "http://192.168.20.152:5052/"; //Neeraj
  BASE_URL = "http://192.168.60.226:8081/"; //Abhisekh
  // BASE_URL = "https://cmp.sourcingbrains.com/backend/"; //production
} else if (hostname.includes("cmp.sourcingbrains.com")) {
  BASE_URL = "https://cmp.sourcingbrains.com/backend/"; //production
} else if (hostname.includes("staging.sourcingbrains.com")) {
  BASE_URL = "http://192.168.30.33:8081/"; //staging
} else {
  BASE_URL = "http://192.168.30.33:7061/";
}

export { BASE_URL };
export const IMAGE_URL = "https://storage.nyggs.com/setmedia/";

export const ENDPOINTS = {
  login: "sim-auth/v2/login",
  getAllProvider: "sim-inventory/get/all/provider",
  uploadFile: "sim-inventory/ais/esim/addAll/inventory",
  getAllSimActivationList: "sim-inventory/api/get/sim/request/status/all",
  getAllAction: "sim-inventory/api/get/all/action",
  getESimDevice: "sim-inventory/ais/esim/device",
  getSimPlan: "sim-inventory/api/get/all/plan",
  getSimProfile: "sim-inventory/get/all/profile",
  getState: "sim-inventory/get/all/state",
  addSimActivation: "sim-inventory/sim/activation",
  getSimRequest: "sim-inventory/api/get/sim/request/status",
  getDeviceWhitelist:
    "sim-inventory/inventory/api/ais/esim/device/whitelist/all",
  addWhiteListData: "sim-inventory/inventory/api/ais/esim/device/whitelist",
  removeDeviceInWhitelist:
    "sim-inventory/inventory/api/ais/esim/device/whitelist/remove",
  deviceRequestApproved: "sim-inventory/esim/status/update",
  getAllKycList: "kyc/all",
  getAllDocList: "kyc/required/documents",
  checkKycByMobile: "kyc/search",
  submitKyc: "kyc/save_documents",
  imageSaver: "api/save/file",
  approveKYC: "kyc/approve_documents",

  addVendor: "vendors/v1/onboard-vendor",
  getVendor: "vendors/v1/getAllVendors",
  getVendorDropdowns: "vendors/v1/dashboard/drop-downs",
  vendorStatusUpdate: "vendors/v1/active-inactive/vendor",
  vendorExportAll: "vendors/v1/get/all/vendor-data",

  // new Endpoints
  getAllAccountCustomer: "http://192.168.40.227:8081/api/v1/account/all",
  createAccountCustomer: "http://192.168.40.227:8081/api/v1/account/create",
};
